import { render, staticRenderFns } from "./GlobalVariableFolderManage.vue?vue&type=template&id=2c653a5a"
import script from "./GlobalVariableFolderManage.vue?vue&type=script&lang=js"
export * from "./GlobalVariableFolderManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports